import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "../../../configuration";
import { FetchError, GetTeamStatisticsDto } from "../../types";
import { useAccessToken } from "../../use-access-token";
import { queryKeys } from "../queryKeys";

const useGetTeamStatisticsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamStatisticsRequest({
    queryKey,
    signal,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.teams.getTeamStatistics>>): Promise<GetTeamStatisticsDto> {
    const [{ slug }] = queryKey;
    const accessToken = await getAccessToken();

    const response = await fetch(`${configuration.apiRootUrl}/teams/${slug}/statistics`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      signal,
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamStatisticsRequest };
};

const useGetTeamStatistics = (slug: string | undefined) => {
  const { getTeamStatisticsRequest } = useGetTeamStatisticsRequest();

  return useQuery({
    queryKey: queryKeys.teams.getTeamStatistics(slug),
    queryFn: getTeamStatisticsRequest,
    cacheTime: 0,
  });
};

export { useGetTeamStatistics };
